<template>
    <div class="modal-wrapper" @click="close">
		<div class="modal-container" :class="view == 'form' ? 'modal-container-mini' : 'modal-container-full'" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12">
						IMPORTAR ENTREGAS DE NOTAS E PEDIDOS
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body" :class="view == 'form' ? 'modal-body-mini' : 'modal-body-full'">
				<div class="col-xs container-list">
                    <div v-if="loading" class="row">
                        <div class="col-xs-12">
                            <div class="loading" :class="view == 'form' ? 'loading-mini' : 'loading-full'">
                                <i class="fa fa-circle-notch fa-spin"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="view == 'form'" class="row">
                        <div class="col-xs-12">
                            <DeliveryFormFile label="Selecionar arquivos" icon="fa-file-alt" :files="files" @update="updateFiles" ref="files" />
                        </div>
                        <div v-if="false" class="col-xs-12">
                            <FormCheckbox v-model="form.selection" label="Verificar registros antes de importar" icon="fa-list" ref="selection" />
                        </div>
                    </div>
                    <div v-else-if="view == 'selection'" class="row">
                        <div class="col-xs">
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-lg-offset-2 col-lg-4 list-search">
                                        <FormInput v-model="form.search" label="Busque na entrega" type="text" icon="fa-search" ref="search" />
                                    </div>
                                    <div class="col-xs-12 col-lg-4 list-search">
                                        <FormSelect v-model="form.filter" label="Exibir entregas" :options="form.options" icon="fa-sort" @blur="searchedList()" ref="filter" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-lg-6 start-xs list-name"><h4>Entregas</h4></div>
                                    <div class="col-xs-12 col-lg-6 end-xs list-total text-right"><h4>Selecionadas: {{ selected.length }} de {{ total }}</h4></div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="row list-head">
                                    <div class="col-xs-1 list-head-item pointer" @click="onSelectAll()"><i :class="selected.length == total ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                    <div class="col-xs-1 list-head-item">Número</div>
                                    <div class="col-xs-1 list-head-item">Tipo</div>
                                    <div class="col-xs-1 list-head-item">Data</div>
                                    <div class="col-xs-1 list-head-item">Cliente</div>
                                    <div class="col-xs-1 list-head-item">Motorista</div>
                                    <div class="col-xs-1 list-head-item">Veículo</div>
                                    <div class="col-xs-1 list-head-item">Carga</div>
                                    <div class="col-xs-1 list-head-item">Sequência</div>
                                    <div class="col-xs-1 list-head-item">Peso</div>
                                    <div class="col-xs-1 list-head-item">Situação</div>
                                    <div class="col-xs-1 list-head-item">Opção</div>
                                </div>
                            </div>
                            <div v-if="searchedList().length > 0" class="col-xs-12 list list-body">
                                <div v-for="(item, indexFile) in searchedList()" :key="'item-' + indexFile">
                                    <div v-if="(typeof item !== 'undefined')">
                                        <div class="row collapsed-list">
                                            <div class="col-xs-12 collapsed-list-head">
                                                <div class="row">
                                                    <div class="col-xs-11" :class="!item.error ? 'pointer' : 'not-allowed'" @click="onSelectAll(!item.error ? item.registers : {})">
                                                        <i :class="includesAll(!item.error ? item.registers : {}) ? 'fas fa-check-square' : 'far fa-square'" style="margin-right: 10px"></i> {{ item.file.name }}
                                                    </div>
                                                    <div class="col-xs-1 collapsed-list-head-button pointer" @click="hideCollapsedBody(indexFile)"><i :id="'collapsed-button-' + indexFile" class="fas fa-angle-down"></i></div>
                                                </div>
                                            </div>
                                            <div :id="'collapsed-list-body-' + indexFile" v-if="!item.error" class="col-xs-12 collapsed-list-body">
                                                <div v-if="item.registers.length > 0">
                                                    <div v-for="(register, indexRegister) in item.registers" :key="'register-' + indexRegister">
                                                        <div v-if="!register.error || register.uploaded" class="row list-body-item">
                                                            <div class="col-xs-1 list-body-item-text pointer" @click="onSelect(register)"><i :class="includes(register) ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.document_number }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.type ? "Pedido" : "Nota F." }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ getFormatedDate(register.delivery.date) }}</div>
                                                            <div class="col-xs-1 list-body-item-text capitalized">{{ register.customer.name.toLowerCase() }}</div>
                                                            <div class="col-xs-1 list-body-item-text capitalized">{{ register.driver.name ? register.driver.name.toLowerCase() : "Não definido" }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.driver.license_plate ? register.driver.license_plate : "Não definido" }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.cargo ? register.delivery.cargo : "Não definida" }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.sequence }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ getWeight(register.delivery.weight) }}</div>
                                                            <div class="col-xs-1 list-body-item-text resume" :class="(register.error || (register.message == 'Foi identificado mais de uma posição possível para o endereço.')) ? 'error' : 'success'">{{ (register.error || (register.message == 'Foi identificado mais de uma posição possível para o endereço.')) ? register.message : 'Pronto para importar.' }}</div>
                                                            <div class="col-xs-1 list-body-item-text">
                                                                <button class="button-edit" title="Ver no mapa" :disabled="register.error" @click="showInMap(register, indexFile, indexRegister)">
                                                                    <i class="fa fa-fw fa-edit"></i> Editar posição
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div v-else class="row list-body-item">
                                                            <div class="col-xs-12 resume error"><i>{{ register.message }}</i></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="row list-body-error">
                                                        <div class="col-xs-12 resume error"><i>Não foram encontrados registros válidos de entregas no arquivo.</i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="col-xs-12 collapsed-list-body">
                                                <div class="row list-body-item-error">
                                                    <div class="col-xs-12 list-body-item-text error">{{ item.message }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="col-xs-12 text-center">
                                <small><i>Não foram encontrados registros de Notas ou Pedidos.</i></small>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="view == 'imported'" class="row">
                        <div class="col-xs">
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-lg-4 start-xs list-name" style="margin-top: 15px;"><h4>Entregas</h4></div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <div class="row list-head">
                                    <div class="col-xs-1 list-head-item">#</div>
                                    <div class="col-xs-1 list-head-item">Número</div>
                                    <div class="col-xs-1 list-head-item">Tipo</div>
                                    <div class="col-xs-1 list-head-item">Data</div>
                                    <div class="col-xs-1 list-head-item">Cliente</div>
                                    <div class="col-xs-1 list-head-item">Motorista</div>
                                    <div class="col-xs-1 list-head-item">Veículo</div>
                                    <div class="col-xs-1 list-head-item">Carga</div>
                                    <div class="col-xs-1 list-head-item">Sequência</div>
                                    <div class="col-xs-1 list-head-item">Peso</div>
                                    <div class="col-xs-2 list-head-item">Resumo</div>
                                </div>
                            </div>
                            <div v-if="list.length > 0" class="col-xs-12 list list-body">
                                <div v-for="(item, indexFile) in list" :key="'item-' + indexFile">
                                    <div v-if="(typeof item !== 'undefined')">
                                        <div class="row collapsed-list">
                                            <div class="col-xs-12 collapsed-list-head">
                                                <div class="row">
                                                    <div class="col-xs-11">{{ item.file.name }}</div>
                                                    <div class="col-xs-1 collapsed-list-head-button pointer" @click="hideCollapsedBody(indexFile)"><i :id="'collapsed-button-' + indexFile" class="fas fa-angle-down"></i></div>
                                                </div>
                                            </div>
                                            <div :id="'collapsed-list-body-' + indexFile" v-if="!item.error" class="col-xs-12 collapsed-list-body">
                                                <div v-if="item.registers.length > 0">
                                                    <div v-for="(register, indexRegister) in item.registers" :key="'register-' + indexRegister">
                                                        <div v-if="!register.error || register.uploaded" class="row list-body-item">
                                                            <div class="col-xs-1 list-body-item-text">
                                                                <span v-if="!register.uploaded" class="gray"><i class="fas fa-fw fa-circle-notch fa-spin"></i></span>
                                                                <span v-else :class="register.error ? 'error' : 'success'"><i class="fas fa-fw" :class="register.error ? 'fa-times-circle' : 'fa-check-circle'"></i></span>
                                                            </div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.document_number }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.type ? "Pedido" : "Nota F." }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ getFormatedDate(register.delivery.date) }}</div>
                                                            <div class="col-xs-1 list-body-item-text capitalized">{{ register.customer.name.toLowerCase() }}</div>
                                                            <div class="col-xs-1 list-body-item-text capitalized">{{ register.driver.name ? register.driver.name.toLowerCase() : "Não definido" }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.driver.license_plate ? register.driver.license_plate : "Não definido" }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.cargo ? register.delivery.cargo : "Não definida" }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ register.delivery.sequence }}</div>
                                                            <div class="col-xs-1 list-body-item-text">{{ getWeight(register.delivery.weight) }}</div>
                                                            <div class="col-xs-2 list-body-item-text resume">
                                                                <span v-if="register.uploaded" :class="register.error ? 'error' : 'success'">{{ register.message }}</span>
                                                            </div>
                                                        </div>
                                                        <div v-else class="row list-body-error">
                                                            <div class="col-xs-12 resume error"><i>{{ register.message }}</i></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="row list-body-error">
                                                        <div class="col-xs-12 resume error"><i>Não foram encontrados registros válidos de entregas no arquivo.</i></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="col-xs-12 collapsed-list-body">
                                                <div class="row list-body-item-error">
                                                    <div class="col-xs-12 list-body-item-text error">{{ item.message }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="view == 'map'" class="row">
                        <div class="col-xs-12">
                            <div class="card card-map">
                                <div class="card-head">
                                    <span class="card-head-title"><b>Resumo</b></span>
                                </div>
                                <div class="card-body-customer">
                                    <div class="card-body-customer-item">
                                        <div class="card-body-customer-left">Cliente</div>
                                        <div class="card-body-customer-right capitalized">{{ current_in_map.customer.name.toLowerCase() }}</div>
                                    </div>
                                    <div class="card-body-customer-item">
                                        <div class="card-body-customer-left">Endereço retornado</div>
                                        <div class="card-body-customer-right capitalized">{{ formatedAddress(current_in_map.address.street, current_in_map.address.number, current_in_map.address.neighborhood, current_in_map.address.city, current_in_map.address.uf, current_in_map.address.postal_code) }}</div>
                                    </div>
                                    <div class="card-body-customer-item">
                                        <div class="card-body-customer-left">Pedido</div>
                                        <div class="card-body-customer-right">{{ current_in_map.delivery.document_number }}</div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <p class="card-body-address">Posições sugeridas:</p>
                                    <div v-for="(location, index) in current_in_map.address.locations" :key="'location-' + index" class="address-info-body-inner">
                                        <div class="row address-info-item pointer" @click="selectPosition(index)">
                                            <div class="col-xs-2 address-info-item-left"><i :class=" location.selected ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                            <div class="col-xs-10 address-info-item-right capitalized">{{ location.formatted_address }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="map col-xs-12" ref="map"></div>
                    </div>
                </div>
			</div>
			<div class="modal-footer">
                <div v-if="view == 'form'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="upload">
                            ENVIAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-upload'"></i>
                        </button>
                    </div>
                </div>
				<div v-else-if="view == 'selection'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                        <button class="modal-button-back" @click="back" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-angle-left'"></i> VOLTAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="save">
                            IMPORTAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-save'"></i>
                        </button>
                    </div>
                </div>
                <div v-else-if="view == 'imported'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> FECHAR
                        </button>
                        <button class="modal-button-back" @click="backToSelection" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-angle-left'"></i> VOLTAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" @click="close" :disabled="loading">
                            FECHAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i>
                        </button>
                    </div>
                </div>
                <div v-else-if="view == 'map'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-back" @click="backToSelection" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-angle-left'"></i> VOLTAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="defineCurrentNewPosition">
                            DEFINIR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-map-marker-alt'"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import DeliveryFormFile from "../Delivery/DeliveryFormFile";
import FormCheckbox from "@/components/FormCheckbox";
import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";
import GoogleMapsApiLoader from 'google-maps-api-loader';

export default {
	name: "DeliveryImport",

    props: [ "files" ],

	components: {
        DeliveryFormFile,
        FormCheckbox,
        FormInput,
        FormSelect,
    },

	data: function() {
		return {
			loading: false,
            
            form: {
                files: this.files,
                selection: 1,
                search: "",
                filter: "",
                options: {
                    "all": "Todas as entregas",
                    "ready": "Pronta para importar",
                    //"needs_attention": "Necessita de atenção",
                    "with_error": "Com erro",
                }
            },
            view: "form",
            
            list: [],
            total: 0,
            selected: [],
            
            current_in_map: null,
            current_index_file: null,
            current_index_register: null,
            current_new_location: null,
            
            new_locations_index: [],
            new_locations_value: [],
            
            google: null,
            map: null,
            geocoder: null,
            marker: null,
            infowindow: null,
		}
	},

	methods: {// Busca com os dados da Web API Atak
        upload: async function() {
            // Inicia a sincronização
            this.loading = true;
            
            // Define o resultado
            let result = false;
            
            // Obtém os arquivos enviados
            let files = this.$refs.files.getValue();
            
            // Verifica se foi selecionado algum arquivo
            if (files.length > 0) {
                // Faz o request
                try {
                    result = await Api.upload("delivery/upload", files);
                } catch (ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível importar os pedidos.");
                    this.loading = false;
                    return false;
                }
                // Termina o request
                
                // Verifica se houve error
                if (result.error) {
                    this.$notification.error(result.data);
                    this.loading = false;
                    return false;
                } else {
                    // Verifica se houve
                    if(result.data) {
                        if(result.total > 0) {
                            // Ordena os arquivos enviados
                            result.data.sort(function(a, b) {
                                if (!a.error && (b.error || (!b.error && b.message == 'Foi identificado mais de uma posição possível para o endereço.'))) return 1;
                                else if ((a.error || (!a.error && a.message == 'Foi identificado mais de uma posição possível para o endereço.')) && b.error) return -1;
                                else return 0;
                            });
                            
                            // Seleciona os registros encontrados nos arquivos
                            let total = 0;
                            result.data.map(file => {
                                if (!file.error) {
                                    file.registers.sort(function(a, b) {
                                        if (!a.error && !b.error) return -1;
                                        else if (!a.error && b.error) return 1;
                                        else if (a.error && !b.error) return 1;
                                        else return 0;
                                    });
                                    file.registers.map(register => {
                                        if (!register.error) {
                                            this.selected.push(register);
                                            total++;
                                        }
                                    });
                                }
                            });
                            
                            // Armazena os resultado
                            this.list = result.data;
                            this.total = total;

                            // Verifica se é para importar o registros
                            if(this.form.selection) {
                                // Exibe a lista de seleção
                                this.view = "selection";
                            } else {
                                // Importa os registros
                                this.save();
                            }
                        } else {
                            // Retorna o modal ao formulário
                            this.view = "form";
                            this.$notification.error("Não foram encontrados registros entregas nos arquivos.");
                        }
                    } else {
                        // Retorna o modal ao formulário
                        this.view = "form";
                        this.$notification.error("Não foi possível importar os registros de entregas.");
                    }
                }
            } else {
                // Retorna o modal ao formulário
                this.view = "form";
                this.$notification.error("Envie ao menos um arquivo contendo registros de entregas.");
            }
            
            // Finaliza a sincronização
            this.loading = false;

            return;
		},

        // Salva os registros importados de dados dos arquivos
        save: async function() {
            // Exibe a lista de sincronização
            this.view = "imported";

            // Solicita para cada registro
            for (let item of this.list) {
                for (let register of item.registers) {
                    // Verifica se tem error
                    if (!register.error) {
                        // Faz o request
                        register.uploaded = false;

                        this.$forceUpdate();

                        // Inicia a variável de retorno
                        let result = false;
                        try {
                            result = await Api.post("delivery/save-delivery", {
                                data: register,
                                file: item.file,
                            });
                        } catch (ex) {
                            console.log(ex);
                            register.uploaded = true;
                            register.error = true;
                            register.message = "Erro ao importar.";
                            continue;
                        }
                        register.uploaded = true;
                        // Termina o request

                        // Verifica se houve erro
                        if (!result.error) {
                            register.error = false;
                            register.message = "Importado.";
                        } else {
                            register.error = true;
                            register.message = result.data;
                        }
                        // Força a atualização da lista
                        this.$forceUpdate();
                    }
                }
            }
            return;
        },
        
        // Filtra com a lista
        searchedList: function() {
            if(this.form.search) {
                let exp = new RegExp(this.form.search.trim(), 'i');
                let searched_list = this.list.map(item => {
                    if (!item.error) {
                        return {
                            "file": item.file,
                            "error": item.error,
                            "registers": item.registers.filter(register => 
                                !register.error ?
                                    exp.test(register.delivery.document_number) || 
                                    exp.test(this.getFormatedDate(register.delivery.date)) || 
                                    exp.test(register.delivery.weight) || 
                                    exp.test(register.customer.document) || 
                                    exp.test(register.customer.name) || 
                                    exp.test(register.address.postal_code) || 
                                    exp.test(register.address.street) || 
                                    exp.test(register.address.number) || 
                                    exp.test(register.address.neighborhood) || 
                                    exp.test(register.address.city) || 
                                    exp.test(register.address.uf)
                                : false
                            ),
                        };
                    }
                });
               if (this.form.filter) {
                    return this.filtredList(searched_list);
                } else {
                    return searched_list;
                }
            } else {
               if (this.form.filter) {
                    return this.filtredList(this.list);
                } else {
                    return this.list;
                }
            }
        },

        // Filtra a lista
        filtredList: function(searched_list) {
            if (this.form.filter == "all") {
                return searched_list;
            } else if (this.form.filter == "ready") {
                return searched_list.map(item => {
                    if (!item.error) {
                        return {
                            "file": item.file,
                            "error": item.error,
                            "registers": item.registers.filter(register => (!register.error && (register.message == '')) ? true : false),
                        };
                    }
                });
            } /*else if (this.form.filter == "needs_attention") {
                return searched_list.map(item => {
                    if (!item.error) {
                        return {
                            "file": item.file,
                            "error": item.error,
                            "registers": item.registers.filter(register => (!register.error && (register.message == 'Foi identificado mais de uma posição possível para o endereço.')) ? true : false),
                        };
                    }
                });
            }*/ else if (this.form.filter == "with_error") {
                return searched_list.map(item => {
                    if (!item.error) {
                        return {
                            "file": item.file,
                            "error": item.error,
                            "registers": item.registers.filter(register => (register.error || (!register.error && (register.message == 'Foi identificado mais de uma posição possível para o endereço.'))) ? true : false),
                        };
                    }
                });
            } else {
                return searched_list;
            }
        },

        // Seleciona os registros que serão syncronizados
        onSelectAll: function(registers) {
            if (typeof registers !== 'undefined') {
                let result = true;
                registers.map(register => {
                    if (!this.selected.includes(register) && !register.error) {
                        result = false;
                    }
                });

                if (!result) {
                    registers.map(register => {
                        if (!this.selected.includes(register) && !register.error) {
                            this.selected.push(register);
                        }
                    });
                } else {
                    registers.map(register => {
                        let index = this.selected.indexOf(register);
                        if(index !== false) {
                            this.selected.splice(index, 1);
                        }
                    });
                }
            } else {
                if (this.selected.length != this.total) {
                    this.list.map(item => {
                        if (!item.error) {
                            item.registers.map(register => {
                                if (!this.selected.includes(register) && !register.error) {
                                    this.selected.push(register);
                                }
                            });
                        }
                    });
                } else {
                    this.list.map(item => {
                        if (!item.error) {
                            item.registers.map(register => {
                                let index = this.selected.indexOf(register);
                                if(index !== false) {
                                    this.selected.splice(index, 1);
                                }
                            });
                        }
                    });
                }
            }
        },

        // Seleciona os registros que serão syncronizados
        onSelect: function(register) {
            if (this.selected.includes(register)) {
                let index = this.selected.indexOf(register);
                if(index !== false) {
                    this.selected.splice(index, 1);
                }
            } else {
                if (!register.error) {
                    this.selected.push(register);
                }
            }
        },
        
        // Verifica se todos estão selecionados
        includesAll: function(registers) {
            if (typeof registers !== 'undefined') {
                let result = true;
                if (registers.length > 0) {
                    registers.forEach(register => {
                        if (!this.selected.includes(register)) {
                            result = false;
                        }
                    });
                } else {
                    result = false;
                }
                return result;
            } else {
                return false;
            }
        },
        
        // Verifica se foi selecionado
        includes: function(register) {
            if (typeof register !== 'undefined') {
                return this.selected.includes(register);
            } else {
                return false;
            }
        },

		// Seleciona 
        showInMap: async function(register, indexFile, indexRegister) {
            this.current_in_map = register;
            this.current_index_file = indexFile;
            this.current_index_register = indexRegister;
            this.view = "map";
            await this.initializeGoogleMap();
            this.createGoogleDeliveryMarker();
        },

        /**
		 * Gera o mapa com os marcadores no modal
		 **/
        initializeGoogleMap: async function() {
			// Carrega a API do Google Map
			this.google = await GoogleMapsApiLoader({
				apiKey: this.$api.config.B2B_GOOLE_API_KEY
			});
			
			// Define o centro
            let coordinate = {};
            this.current_in_map.address.locations.forEach(element => {
                // Verifica se a localização selecionada
                if (element.selected) {
                    // Verifica se já foi editada
                    if (typeof element.location_updated != "undefined") {
                        coordinate = {
                            lat: parseFloat(element.location_updated.lat),
                            lng: parseFloat(element.location_updated.lng),
                        };
                    } else {
                        coordinate = {
                            lat: parseFloat(element.location.lat),
                            lng: parseFloat(element.location.lng),
                        };
                    }
                }
            });
            
            // Cria o mapa
			let map = new this.google.maps.Map(this.$refs.map, {
				center: { lat: coordinate.lat, lng: coordinate.lng },
				backgroundColor: "#fefefe",
				zoom: 14,
				zoomControl: true,
				zoomControlOptions: {
					position: this.google.maps.ControlPosition.RIGHT_TOP,
				},
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				styles: [
					/*{
						featureType: "poi",
						stylers: [{
							visibility: "off",
						}],
					}, */{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [{
							visibility: "off",
						}],
					},
				],
			});

            // Cria o geocoder
			let geocoder = new this.google.maps.Geocoder();

			// Define o objeto do mapa
            this.map = map;
            this.geocoder = geocoder;
        },

        /**
		 * Adiciona o marcador do ponto de entrega
		 **/
        createGoogleDeliveryMarker: function(by_selection = false) {
            // Defien a posição
			let coordinate = {};
			let popup = "";
            this.current_in_map.address.locations.forEach(element => {
                // Verifica se a localização selecionada
                if (element.selected) {
                    // Verifica se está sendo criado a partir da seleção
                    if (by_selection) {
                        coordinate = {
                            lat: parseFloat(element.location.lat),
                            lng: parseFloat(element.location.lng),
                        };
                    } else { 
                        // Verifica se já foi editada
                        if (typeof element.location_updated != "undefined") {
                            coordinate = {
                                lat: parseFloat(element.location_updated.lat),
                                lng: parseFloat(element.location_updated.lng),
                            };
                        } else {
                            coordinate = {
                                lat: parseFloat(element.location.lat),
                                lng: parseFloat(element.location.lng),
                            };
                        }
                    }

                    // Define o texto do popup
                    popup = element.formatted_address;
                }
            });

			let label = "Local da entrega";

            // Determina o marcador da posiçaõ do APP e coloca no mapa
			let marker = new this.google.maps.Marker({
				position: { lat: coordinate.lat, lng: coordinate.lng },
				map: this.map,
				icon: {
					url: require("@/assets/end_marker.svg"),
					size: new this.google.maps.Size(40, 40),
					scaledSize: new this.google.maps.Size(40, 40),
					origin: new this.google.maps.Point(0, 0),
					anchor: new this.google.maps.Point(20, 40),
					labelOrigin: new this.google.maps.Point(20, 50),
				},
                draggable: true,
				title: label,
				zIndex: 20,
			});
			
			// Define as informações que aparecerão no popup
			let infowindow = new this.google.maps.InfoWindow({
				content: '<div class="capitalized">' + popup + '</div>',
				pixelOffet: new this.google.maps.Point(0, 0),
			});
			
			// abre o popup ao passar o mouse por cima do marcador
			this.google.maps.event.addListener(marker, "mouseover", function() {
				infowindow.open(this.map, marker);
			});
			
			// Fecha o popup ao retirar o mouse de cima do marcador
			this.google.maps.event.addListener(marker, "mouseout", function() {
				infowindow.close(this.map, marker);
			});

            // Armazena a nova posiçaõ do marcador
            let updateLocation = this.updateLocation;
            let updateMarker = this.updateMarker;
			this.google.maps.event.addListener(marker, "dragend", async function(event) {
				updateLocation(event.latLng.lat(), event.latLng.lng());
                let newContent = await updateMarker(marker.getPosition());
                infowindow.setContent(newContent);
			});
            
            // Define o centro
            this.map.setCenter(new this.google.maps.LatLng(coordinate.lat, coordinate.lng));

            // Salva o marcador
            this.marker = marker;

            // Salva o popup
            this.infowindow = infowindow;
        },
        
        // Seleciona posição na lista
        selectPosition: function(index) {
            // Remove o marcador do mapa
            this.marker.setMap(null);

            // Atualiza a nova posição editada
            let location_original = {};
            
            // Atualiza a nova posição marcada
            this.current_in_map.address.locations.forEach((element, key) => {
                if (index == key) {
                    element.selected = true;
                    
                    // Obtém a posição original
                    location_original = {
                        lat: element.location.lat, 
                        lng: element.location.lng
                    };
                } else {
                    element.selected = false;
                }
            });

            // Percorre todos os registros da listagem
            this.list.map(item => {
                if (!item.error) {
                    item.registers.map(register => {
                        // Verifca se não é o registro atual
                        if (register != this.current_in_map) {
                            // Percorre todas as posições do registro
                            register.address.locations.map(element => {
                                if ((parseFloat(element.location.lat) == parseFloat(location_original.lat)) && (parseFloat(element.location.lng) == parseFloat(location_original.lng))) {
                                    // Salva a posição atualizada
                                    delete element.location_updated;
                                }
                            });
                        }
                    });
                }
            });
            
            // Limpa a posição
            this.current_new_location = null;

            // Adiciona o novo marcador
            this.createGoogleDeliveryMarker(true);
            
            // Atualiza a DOM
            this.$forceUpdate();
        },
        
        // Obtem a nova posição
        updateLocation: function(lat, lng) {
            this.current_new_location = {
                lat: lat,
                lng: lng,
            };
        },
        
        // Atualiza o popup do marcador
        updateMarker: async function(latLng) {
            let formatted_address = "";

            await this.geocoder.geocode({
                latLng: latLng
            }, function(responses) {
                if (responses && responses.length > 0) {
                    formatted_address = responses[0].formatted_address;
                } else {
                    formatted_address = 'Não foi possível determinar o endereço dessa localização';
                }
            });
            
            return '<div class="capitalized">' + formatted_address.replace("State of ", "").replace("Brazil", "Brasil") + '</div>';
        },
        
        // Volta para listagem de seleção
		defineCurrentNewPosition: async function() {
            // Verifica se foi editada a posição
            if (this.current_new_location) {
                // Pede a confirmação
                let confirm = await this.$alert.confirm("Deseja mesmo EDITAR A POSIÇÃO PADRÃO PARA ESTE ENDEREÇO ?", "AVISO");
                
                // Verifica a confirmação
                if(confirm) {
                    // Atualiza a nova posição editada
                    let location_original = {};

                    // Atualiza a nova posição marcada
                    this.current_in_map.address.locations.forEach(element => {
                        // Verifica se é a selecionada
                        if (element.selected) {
                            // Obtém a posição original
                            location_original = {
                                lat: element.location.lat, 
                                lng: element.location.lng
                            };

                            // Salva a posição atualizada
                            element.location_updated = {
                                lat: this.current_new_location.lat,
                                lng: this.current_new_location.lng,
                            };
                        }
                    });

                    // Percorre todos os registros da listagem
                    this.list.map(item => {
                        if (!item.error) {
                            item.registers.map(register => {
                                // Verifca se não é o registro atual
                                if (register != this.current_in_map) {
                                    // Percorre todas as posições do registro
                                    register.address.locations.map(element => {
                                        if ((parseFloat(element.location.lat) == parseFloat(location_original.lat)) && (parseFloat(element.location.lng) == parseFloat(location_original.lng))) {
                                            // Salva a posição atualizada
                                            element.location_updated = {
                                                lat: this.current_new_location.lat,
                                                lng: this.current_new_location.lng,
                                            };
                                            
                                            // Define as demais como selecionadas também
                                            element.selected = true;
                                            
                                            // Retira o erro
                                            register.error = false;
                                            register.message = "";
                                        }
                                    });
                                }
                            });
                        }
                    });
                    
                    // Limpa o mapa
                    this.backToSelection();

                    // Mostra feedback
                    this.$notification.success("Posição atualizada.");
                }
            } else {
                // Verifica se há mais de uma posição
                if (this.current_in_map.address.locations.length > 1) {
                    // Retira a mensagem de erro
                    this.current_in_map.error = false;
                    this.current_in_map.message = "";
                }

                // Limpa o mapa
                this.backToSelection();
            }
		},

        // Voltar o modal
		back: function() {
			this.view = 'form';
            this.list = [];
            this.selected = [];
		},

        // Volta para listagem de seleção
		backToSelection: function() {
            this.view = 'selection';
            this.clearMap();
		},
        
        // Limpa as informações e DIV do mapa
        clearMap: function() {
            this.map = null;
            this.google = null;
            this.current_in_map = null;
            this.current_index_file = null;
            this.current_index_register = null;
            this.current_new_location = null;
            if(typeof document.getElementsByClassName("gm-style")[0] !== "undefined") {
                document.getElementsByClassName("gm-style")[0].parentElement.remove();
            }
        },

        // Formata a data de sincronização
        getFormatedTodayDate: function() {
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0');
            let yyyy = today.getFullYear();
            
            return dd + '/' + mm + '/' + yyyy;
        },
        
        // Formata data de entrega
        getFormatedDate: function(date) {
            let aux = date.split("T")[0];
            let formated = aux.split("-");
            formated = formated.reverse().join("/");
            
            return formated;
        },

        // Retorna o endereço selecionado
        getAddressSelected: function(addresses) {
            let addressSelected = "";
            
            addresses.forEach(address => {
                if (address.selected) {
                    addressSelected = address.formatted_address;
                }
            });

            return addressSelected;
        },
        
        // Formata o endereço
        formatedAddress: function(address, number, neighborhood, city, uf, postal_code) {
            let formated_address = "";

            if(address) {
                formated_address += address.toLowerCase();
            }
            
            if(number) {
                formated_address += ", " + number.toLowerCase();
            }
            
            if(neighborhood) {
                formated_address += " - " + neighborhood.toLowerCase();
            }
            
            if(city) {
                formated_address += ", " + city.toLowerCase();
            }
            
            if(uf) {
                formated_address += " - " + uf.toUpperCase();
            }
            
            if(postal_code) {
                formated_address += ", " + postal_code;
            }

            return formated_address;
        },
        
        // Formata o texto passado
        formatedText: function(text) {
            let formated_text = "";

            formated_text = text.toLowerCase();
            
            return formated_text;
        },

        openInputFile: function() {
            this.$parent.$refs.upload_input.click();
        },

        updateFiles: function(index) {
            this.$emit("update", index);
        },

        // Oculta/mostra corpo do modal
        hideCollapsedBody: function(index) {
            let elementButton = document.getElementById("collapsed-button-" + index);
            let elementBody = document.getElementById("collapsed-list-body-" + index);
            if (elementBody.hidden) {
                elementButton.classList.remove("fa-angle-up");
                elementButton.classList.add('fa-angle-down');
                elementBody.hidden = false;
            } else {
                elementButton.classList.remove("fa-angle-down");
                elementButton.classList.add('fa-angle-up');
                elementBody.hidden = true;
            }
        },

        // Fecha o modal
		close: function() {
			this.$parent.show_modal_import = false;
			this.$parent.uploading = [];
            this.$parent.load();
		},

        getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },
	}
}
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-mini {
	width: 600px;
	height: 350px;
}

.modal-container-full {
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	/*padding: 15px;*/
	width: 100%;
	overflow-y: auto;
}

.modal-body-mini {
	height: 240px;
}

.modal-body-full {
    height: calc(100vh - 140px);
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: 61px;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.btn-sync {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}
.btn-sync:disabled {
    background: #a0a0a0;
}

/*.btn-margin-top {
    margin-top: 30px;
}*/

.sync-list {
	position: relative;
	height: 100%;
	overflow: hidden;
}

.sync-list-container {
	float: left;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 15px;
}

.sync-list-item {
	width: 100%;
	float: left;
	background: #eee;
	margin-bottom: 15px;
	padding: 10px;
}

.sync-list-imported-name {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: bold;
}

.sync-list-uploading-status {
	float: left;
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #999;
}

.sync-list-result-collapse { 
	margin-top: 5px;
	margin-bottom: 5px;
}

.sync-list-result-collapse-header {
	width: 100%;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}

.sync-list-result-collapse-body {
	width: 100%;
	padding-left: 10px;
	white-space: nowrap;
	font-size: 11px;
}

.capitalized {
	text-transform: capitalize;
}

.pointer {
    cursor: pointer;
}

.not-allowed {
    cursor: not-allowed;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.list {
    margin-bottom: 30px;
}

.list-name, 
.list-search, 
.list-total {
    display: grid;
    align-content: center;
}

.list-name, 
.list-total {
    border-bottom: 1px solid #ccc;
}

.list-name > h4, 
.list-total > h4 {
    margin-top: 0px;
    margin-bottom: 5px;
}

.list-total > h4 {
    font-size: 1;
    font-weight: 400;
}

.list-head-item {
    /*font-size: 14px;*/
    font-weight: 600;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    background-color: #eee;
}

.list-body-item {
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #ccc;
	border-radius: 3px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
    margin: 10px 0px;
}

.list-body-error {
    /*font-size: 13px;*/
    margin: 10px 0px;
}

.list-body-item-error {
    /*font-size: 14px;*/
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 5px;
}

.list-body-item:hover {
    background-color: #f0f0f0;
}

.list-body-item-cell {
    display: grid;
    align-content: center;
}

.list-body-item-text {
    display: grid;
	align-content: center;
}

.list-body-item-text.resume {
    font-size: 13px;
}

.modal-button-close {
	background: #222;
	border: 2px solid #222;
	color: #fff;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
    margin-right: 15px;
}

.modal-button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save:disabled,
.modal-button-back:disabled,
.modal-button-close:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: #fff;
    color: #ddd;
    font-size: 80px;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-mini {
    width: 600px;
    height: 239px;
    line-height: 239px;
}

.loading-full {
    width: calc(100vw - 30px);
	height: calc(100vh - 141px);
    line-height: calc(100vh - 141px);
}

.error {
    color: red;
}

.success {
    color: green;
}

.gray {
    color: #ddd;
}

.map {
    height: calc(100vh - 140px) !important;
}

.card-map {
	position: absolute;
}

.card {
    height: auto !important;
    width: 370px;
	margin-top: 10px;
	margin-left: 5px;
    background: #fff;
    z-index: 3;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}

.card-head {
    padding: 10px;
    background-color: #eee;
	color: rgb(44, 62, 80);
    font-size: 16px;
}

.card-body {
	height: auto !important;
    max-height: calc(100vh - 230px);
    padding: 10px 10px 0px 10px !important;
    background-color: #fff;
	overflow-y: auto;
}

.address-info-body-inner {
	float: left;
	width: 100%;
	border: 1px solid #ccc;
    border-radius: 4px;
	padding: 0 5px;
    /*color: #666;*/
    margin-bottom: 10px;
}

.address-info-item {
	position: relative;
    padding: 10px;
    float: left;
    width: 100%;
}

.address-info-item-left {
    display: grid;
    align-content: center;
    padding-right: 0px !important;
}

.address-info-item-right {
    display: grid;
    align-content: center;
    padding-left: 0px !important;
    font-size: 13px;
}

.collapsed-list {
    padding: 5px 0px;
}

.collapsed-list-head {
    padding: 10px 10px;
    background-color: #ddd;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    /*color: #666;*/
}

.collapsed-list-head-button {
    text-align: right;
}

.collapsed-list-body {
    border: 1px solid #ddd;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: none;
}

.btn-delivery {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.filter-label {
    position: absolute;
    font-size: 13px;
    margin-top: 8px;
    margin-left: 5px;
}

.filter-clean {
    position: absolute;
    font-size: 15px;
    margin-top: 0px;
    margin-left: -22px;
    height: 30px;
    background-color: transparent;
    border: none;
}

.filter {
    width: 100%;
    height: 30px;
}

select.filter-sort {
    padding-left: 15px;
    background-color: #fff;
    border: 1px solid #8f8f9d;
}

.card-body-customer {
    float: left;
    width: 100%;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
    /*padding: 10px;*/
}

.card-body-customer-item {
	position: relative;
    padding: 10px 15px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.card-body-customer-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
	display: grid;
    align-content: center;
}

.card-body-customer-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}

.card-body-address {
    font-size: 14px;
    font-weight: bold;
}
</style>